/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import Img1 from "./img/webp/WhatsApp Image 2025-12-17 at 13_imgupscaler.ai_General_4K.webp";
import Img2 from "./img/webp/WhatsApp Image 2025-07-30 at 10_imgupscaler.ai_General_4K.webp";
import Img3 from "./img/webp/US-PARKING2.webp";

const carouselItems = [
  {
    img: Img1,
    subtitle: (
    <>
      <span className="subtitle-us">US</span> STRUCTURE
    </>
  ),
    title: "Architecture Textile Haut de Gamme – Structures Sur Mesure",
    text: "Structures textiles architecturales conçues pour sublimer les espaces avec élégance, durabilité et précision technique."
  },
  {
    img: Img2,
    subtitle: (
    <>
      <span className="subtitle-us">US</span> SHADE
    </>
  ),
    title: "Ombrage Textile Intelligent Confort & Performance",
    text: "Solutions d’ombrage textile performantes régulant la luminosité et la chaleur tout en valorisant l’esthétique des espaces extérieurs."
  },
  {
  img: Img3, // تأكد عندك الصورة
  subtitle: (
    <>
      <span className="subtitle-us">US</span> PARKING
    </>
  ),
  title: "Solutions de Parking Innovantes – Protection et Design",
  text: "Structures de parking modernes offrant protection solaire, durabilité et esthétique pour espaces résidentiels et professionnels."
}

];



const HeaderCarousel = () => {
  return (
    <div className="container-fluid p-0" id="section1">

      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        loop={true}
        autoplay={{
          delay: 8000,
          disableOnInteraction: false,
        }}
      >
        {carouselItems.map((item, index) => (
          <SwiperSlide key={index}>
                      <div className="position-relative">
          
                        {/* IMAGE */}
                        <img className="w-100 hero-img" src={item.img} alt={item.alt} loading="lazy"/>
          
                        {/* OVERLAY */}
                        <div className="hero-overlay d-flex align-items-center">
                          <div className="container">
                            <div  className="col-12 col-lg-8">
          
                              <h5 className="text-uppercase mb-2 text-white fw-bold tracking-in">
                                {item.subtitle}
                              </h5>
          
                              <h1 className="display-3 fw-bold text-white mb-4 slide-down" >
                                {item.title}
                              </h1>
          
                              <p className="fs-5 text-white mb-4 slide-up">
                                {item.text}
                              </p>
          
                              <a href="#titre-gallry" className="btn py-md-3 px-md-5 me-3 slide-left" id="pmt-link">
                                Voir nos réalisations
                              </a>
          
                              <a href="/devis" className="btn py-md-3 px-md-5 slide-left" id="pmt-link2">
                                Demander un devis
                              </a>
          
                            </div>
                          </div>
                        </div>
          
                      </div>
                    </SwiperSlide>
        ))}
      </Swiper>

    </div>
  );
};

export default HeaderCarousel;

